import { render, staticRenderFns } from "./GroupSocialPassport.vue?vue&type=template&id=142faec1&"
import script from "./GroupSocialPassport.vue?vue&type=script&lang=js&"
export * from "./GroupSocialPassport.vue?vue&type=script&lang=js&"
import style0 from "./GroupSocialPassport.vue?vue&type=style&index=0&id=142faec1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports